import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appLettersAndNumbers]',
    standalone: false
})
export class LettersAndNumbersDirective {
	constructor(
		private el: ElementRef,
		private ngControl: NgControl
	) {}

	@HostListener('input', ['$event']) onInputChange(event: any) {
		const inputValue = event.target['value'];
		const newValue = inputValue.replace(/[^A-Za-z\d\sáéíóúüñÁÉÍÓÚÜÑ#-]/g, '');

		this.el.nativeElement.value = newValue;
		this.ngControl?.control?.setValue(newValue);
	}
}
